var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPotted = function SvgPotted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 4,
    d: "M44 56.32s-2.15-27.537 4.206-38.112c5.78-9.62 14.895-10.923 19.27-4.81 4.817 6.733-4.525 26.11-35.356 11.682M28.931 83.36l-7.787-26.8h47.473l-7.787 26.8H28.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 4,
    d: "M33.328 26.211c-3.641 7.43-12.616 10.5-20.045 6.86-7.43-3.641 2.187-7.163 5.828-14.592 3.64-7.43-.072-15.954 7.357-12.313 7.43 3.641 10.501 12.616 6.86 20.045Z"
  })));
};
export default SvgPotted;